import resourceService from './resource_service';

const modelName = 'ability';

const attributes = {
  model: '',
  action: '',
};

const relationships = {
  siteAbilities: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships);
